import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FormControl, InputLabel, MenuItem, Select, Theme, createStyles } from '@material-ui/core';
import useDebouncedCallback from 'use-debounce/lib/useDebouncedCallback';
import { SearchInput, SearchDataProps } from 'components';
import { RegularNeedPeriodAttachmentsFilter } from 'schema/serverTypes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      display: 'flex',
      alignItems: 'center',
    },
    search: {
      flexGrow: 1,
    },
    attachments: {
      minWidth: 200,
      marginLeft: theme.spacing(4),
    },
  })
);

const ATTACHMENT_OPTIONS: { value: RegularNeedPeriodAttachmentsFilter; label: string }[] = [
  { value: RegularNeedPeriodAttachmentsFilter.Both, label: 'Фото и документ' },
  { value: RegularNeedPeriodAttachmentsFilter.Any, label: 'Хотя бы одно' },
  { value: RegularNeedPeriodAttachmentsFilter.PhotoOnly, label: 'Только фото' },
  { value: RegularNeedPeriodAttachmentsFilter.DocumentOnly, label: 'Только документ' },
  { value: RegularNeedPeriodAttachmentsFilter.WithDocument, label: 'С документом' },
  { value: RegularNeedPeriodAttachmentsFilter.None, label: 'Ничего' },
];

const ATTACHMENTS_ANY = '__any__';

export interface PeriodsSearchProps extends SearchDataProps<string> {
  attachments?: RegularNeedPeriodAttachmentsFilter;
  onAttachmentsChange: (value: RegularNeedPeriodAttachmentsFilter | undefined) => void;
}

export const PeriodsSearch = (props: PeriodsSearchProps) => {
  const { onSearch, attachments, onAttachmentsChange } = props;
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>();

  const [handleChange] = useDebouncedCallback(() => {
    const value = inputRef.current?.value;
    onSearch(value || undefined);
  }, 500);

  return (
    <div className={classes.row}>
      <SearchInput
        className={classes.search}
        inputRef={inputRef}
        placeholder="Поиск по имени подопечного или городу"
        onChange={handleChange}
      />
      <FormControl size="small" variant="outlined" className={classes.attachments}>
        <InputLabel id="periods-attachments-label">Вложения</InputLabel>
        <Select
          labelId="periods-attachments-label"
          label="Вложения"
          value={attachments ?? ATTACHMENTS_ANY}
          onChange={(e) => {
            const value = e.target.value as string;
            onAttachmentsChange(
              value === ATTACHMENTS_ANY ? undefined : (value as RegularNeedPeriodAttachmentsFilter)
            );
          }}
        >
          <MenuItem value={ATTACHMENTS_ANY}>Не важно</MenuItem>
          {ATTACHMENT_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
